/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ab_FootnoteInputs */

const es_ab_footnote = /** @type {(inputs: Ab_FootnoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registro gratis · sin compromiso · datos protegidos`)
};

const gl_ab_footnote = /** @type {(inputs: Ab_FootnoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rexistro de balde · sen compromiso · datos protexidos`)
};

const en_ab_footnote = /** @type {(inputs: Ab_FootnoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free signup · no commitment · data protected`)
};

/**
* | output |
* | --- |
* | "Free signup · no commitment · data protected" |
*
* @param {Ab_FootnoteInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const ab_footnote = /** @type {((inputs?: Ab_FootnoteInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ab_FootnoteInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_ab_footnote(inputs)
	if (locale === "en") return en_ab_footnote(inputs)
	return es_ab_footnote(inputs)
});